import { render } from "./WCMobileSideBar.vue?vue&type=template&id=289e7028&scoped=true"
import script from "./WCMobileSideBar.vue?vue&type=script&lang=js"
export * from "./WCMobileSideBar.vue?vue&type=script&lang=js"

import "./WCMobileSideBar.vue?vue&type=style&index=0&id=289e7028&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289e7028"]])

export default __exports__